import React from "react";
import { AlertCircle } from "lucide-react";

const focusField = (name) => {
  const el =
    document.querySelector(`[name="${name}"]`) ||
    document.getElementById(name);
  if (el && typeof el.focus === "function") {
    el.focus({ preventScroll: false });
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

const ErrorSummary = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div role="alert" className="pf-error-summary">
      <AlertCircle size={18} className="pf-error-summary__icon" />
      <div>
        <div className="pf-error-summary__title">
          Please fix {errors.length} {errors.length === 1 ? "issue" : "issues"} before saving
        </div>
        <ul className="pf-error-summary__list">
          {errors.map((e) => (
            <li key={e.name}>
              <button type="button" onClick={() => focusField(e.name)}>
                {e.label}: {e.message}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ErrorSummary;
